import axios from 'axios';
import {API_BASE_URL} from '../constants/apiConstants';
import * as auth from '../auth-provider';

async function apiRequest(method, path, payload, headers, callback, errorcallback) {
  axios.defaults.withCredentials = true;
    if (method === 'POST') {
      await axios.post(API_BASE_URL+path, payload, {withCredentials: true, headers: headers})
      .then(async function (response) {
          callback(response);
      })
      .catch(async function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            console.log('Token abgelaufen');
            await auth.logout();
            // refresh the page for them
            window.location.reload();
          } else {
            callback(error.response);
          }
        } else {
          console.log(error);
          if (errorcallback) {
            errorcallback();
          }
          //callback({status: 500, data: {message: 'Server Error'}});
        }
      });
    } else if (method === 'GET') {
      await axios.get(API_BASE_URL+path, {withCredentials: true, headers: headers})
      .then(async function (response) {
          callback(response);
      })
      .catch(async function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            console.log('Token abgelaufen');
            await auth.logout();
            // refresh the page for them
            window.location.reload();
          }
          callback(error.response);
        } else {
          console.log(error);
          //callback({status: 500, data: {message: 'Server Error'}});
        }
      });
    } else {
      console.log('Nothing');
    }
}

export default apiRequest;